// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"59":"6e28aac8e856e0a7","61":"c5414d6c38c2fa3c","178":"dda2ac12c57b4afa","213":"dec817984e56b452","233":"5a551a343b96671e","236":"170dd16df89cbf25","872":"ef2784d68ff1c9d7","913":"bfd9ae75dcc7490f","994":"86cf39a26ffe26bb"}[chunkId] + ".js";
};